import { parseNearAmount } from '@near-js/utils';

export default {
  ACCOUNT_ID_SUFFIX: 'mainnet',
  INDEXER_API: 'https://indexer.openforestprotocol.org',
  REF_FINANCE_API_ENDPOINT: 'https://indexer.ref.finance/',
  COINGECKO_PRICE_URL: 'https://api.coingecko.com/api/v3/simple/price',
  NODE_URL: 'https://rpc.mainnet.near.org',
  WALLET_URL: 'https://wallet.meteorwallet.app',
  SUCCESS_URL: 'https://wallet.openforestprotocol.org/',
  FAILURE_URL: 'https://wallet.openforestprotocol.org/signin',
  DASHBOARD_URL: 'https://dashboard.openforestprotocol.org',
  COLLATERAL_URL: 'https://collateral.openforestprotocol.org',
  VALIDATION_URL: 'https://validation.openforestprotocol.org',
  EXPLORER_URL: 'https://atlas.openforestprotocol.org',

  NEAR_TOKEN_ID: 'wrap.mainnet',
  OPN_CONTRACT: 'opntoken.near',
  OCC_CONTRACT: 'occtoken.near',
  NFT_CONTRACT: 'ofpcore.near',
  USDC_CONTRACT: "17208628f84f5d6ad33f0da3bbbeb27ffcb398eac501a31bd6ad2011e36133a1",
  COLLATERAL_CONTRACT: 'ofpcollateral.near',
  METHODS: {
    storage_deposit: 'storage_deposit',
    storage_balance_bounds: 'storage_balance_bounds',
    storage_balance_of: 'storage_balance_of',
    storage_withdraw: 'storage_withdraw',
    get_user_projects: 'get_user_projects',
    get_profile: 'get_profile',
    get_planting_profile: 'get_planting_profile',
    get_uncollected_planting_rewards: 'get_uncollected_planting_rewards',
    get_collected_planting_rewards: 'get_collected_planting_rewards',
    get_profile_balances: 'get_profile_balances',
    get_collateral_stage: 'get_collateral_stage',
    get_certificates: 'get_certificates',
    ft_metadata: 'ft_metadata',
    ft_transfer: 'ft_transfer',
    ft_balance_of:'ft_balance_of',
    mt_metadata_base_by_metadata_id: 'mt_metadata_base_by_metadata_id',
    mt_offset: 'mt_offset',
    mt_batch_transfer: 'mt_batch_transfer',
    plant_tokens: 'plant_tokens',
    revoke_planted_tokens: 'revoke_planted_tokens',
    collect_planting_rewards: 'collect_planting_rewards',
    withdraw_planting_rewards: 'withdraw_planting_rewards',
    withdraw_planted_tokens:'withdraw_planted_tokens',

  },
  ONE_NEAR_DEPOSIT: parseNearAmount('1'),
  FT_MINIMUM_STORAGE_BALANCE: parseNearAmount('0.00125'),
  FT_MINIMUM_STORAGE_BALANCE_LARGE: parseNearAmount('0.00359'),
  FT_MAXIMUM_STORAGE_BALANCE_LARGE: parseNearAmount('0.01'),

  OCC_STORAGE_BALANCE: parseNearAmount('0.008'),
  MIN_BALANCE_FOR_GAS: parseNearAmount('0.05'),
  TOKEN_TRANSFER_DEPOSIT: '1', // 1 yoctoNear
  FT_TRANSFER_GAS: '15000000000000',
  FT_STORAGE_DEPOSIT_GAS: '300000000000000',
  MAX_GAS: '300000000000000',
  PLANT_OPN_GAS: '300000000000000',
  WITHDRAW_OCC_GAS: '200000000000000',
  RECEIVE_OCC_GAS: '100000000000000',
  SEND_NEAR_GAS: '450000000000',
  PLANT_LIST:['aureline.near','techteamm.near']
};
